import { Routes, Route, useLocation } from "react-router-dom";
import {
  Navbar,
  Footer,
  PrivacyPolicy,
  TermsnConditions,
  Disclaimer,
  ShippingandDelivery,
  ReturnPolicy,
  Error404,
  Home,
  Aboutus,
  Contactus,
  Services,
  FAQ,
} from "./routes/Routes";

import seoData from "./assets/data/seo.json";

import PrivateRoute from "./hooks/PrivateRoute";
import Operations from "./routes/Operations.js";



import Login from "./routes/auth/login";
import Dashboard from "./routes/auth/dashboard";
import Leads from "./routes/auth/Leads";
import AdminContactus from "./routes/auth/AdminContactus";
import AdminNavbar from "./routes/auth/AdminNavbar.js";
import GoogelAnalytics from "./routes/auth/GoogelAnalytics";
import MyAccount from "./routes/auth/MyAccount";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/*", element: <Error404 /> },

  { path: "/login", element: <Login /> },
  {
    path: "/auth/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/contactus",
    element: (
      <PrivateRoute>
        <AdminContactus />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/leads",
    element: (
      <PrivateRoute>
        <Leads />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/google-analytics",
    element: (
      <PrivateRoute>
        <GoogelAnalytics />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/my-account",
    element: (
      <PrivateRoute>
        <MyAccount />
      </PrivateRoute>
    ),
  },

  { path: "/aboutus", element: <Aboutus /> },

  { path: "/operations", element: <Operations /> },
  { path: "/contactus", element: <Contactus /> },
  { path: "/Legal/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/Legal/terms-and-conditions", element: <TermsnConditions /> },
  { path: "/Legal/return-policy", element: <ReturnPolicy /> },
  { path: "/Legal/shipping-and-delivery", element: <ShippingandDelivery /> },
  { path: "/Legal/disclaimer", element: <Disclaimer /> },

  { path: "/services", element: <Services /> },
  { path: "/frequently-asked-questions", element: <FAQ /> },

];

export function App() {
  const location = useLocation();

  // Any route that starts with "/auth" (e.g., /auth/dashboard, /auth/contactus)
  const isAuthRoute =
    location.pathname.startsWith("/auth") &&
    location.pathname !== "/login";

  window.scrollTo(0, 0);

  return (
    <>
      {isAuthRoute && <AdminNavbar />}
      {!isAuthRoute && <Navbar />}

      <div className="flex flex-1">
        <div
          className={`flex-1 min-w-0 transition-all duration-300 ${isAuthRoute ? "mt-14 md:ml-64" : "mt-0"
            }`}
        >
          <Routes location={location} key={location.pathname}>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>

          {!isAuthRoute && <Footer />}
        </div>
      </div>
    </>
  );
}

export default App;
